import { memo, useContext, useState } from 'react';
import { Dropdown, DropdownToggle, DropdownMenu } from 'reactstrap';
import * as AppPics from 'assets/images';
import { useHistory } from 'react-router-dom';
import { UserContext } from 'context/UserContext';

function ClassDropDownMenu({ classDetails = {} }) {
  const history = useHistory();
  const { userPermissions = {} } = useContext(UserContext);

  const [dropdownOpen, setDropdownOpen] = useState(false);

  const dpToggle = () => setDropdownOpen((prevState) => !prevState);

  return (
    <Dropdown isOpen={dropdownOpen} toggle={dpToggle}>
      <DropdownToggle tag="span" data-toggle="dropdown" aria-expanded={dropdownOpen}>
        <button className="btn-more">
          <img src={AppPics.MoreOptPng} alt="" />
        </button>
      </DropdownToggle>
      {userPermissions?.class?.canEditExisting && (
        <DropdownMenu>
          <div
            onClick={() => {
              history.push(`/manage/classes/edit/${classDetails._id}`);
              dpToggle();
            }}
          >
            Edit
          </div>
        </DropdownMenu>
      )}
    </Dropdown>
  );
}

export default memo(ClassDropDownMenu);
